import api from '@/services/api'
import useLoading from '@/composables/useLoading'
import useResponse from '@/composables/useResponse'
import { computed, ref, watch } from '@vue/composition-api'
import router from '@/router'
import { isNull } from '@/util/inspect'

export default function useDistrict() {
  const list = ref([])
  const region = ref({
    id: null,
    name: '',
  })
  const pagination = ref({
    page: 1,
    perPage: 10,
    totalPage: 1,
  })

  const { isLoading, startLoading, finishLoading } = useLoading()

  const tableColumns = [
    { key: 'id', label: '#' },
    { key: 'name', label: 'Name' },
    { key: 'actions', label: 'Actions' },
  ]

  const paginationMeta = computed(() => ({
    from: pagination.value.perPage * (pagination.value.page - 1) + (list.value.length ? 1 : 0),
    to: pagination.value.perPage * (pagination.value.page - 1) + list.value.length,
    of: pagination.value.totalPage,
  }))

  // eslint-disable-next-line radix
  const idOfRegion = computed(() => parseInt(router.currentRoute.params.id))

  // eslint-disable-next-line no-use-before-define
  watch(() => pagination.value.page, findAll)

  function resetList() {
    list.value = []
  }

  async function findAll({ regionId = null } = { regionId: null }) {
    try {
      startLoading()
      const response = useResponse(
        await api.district.findAll({
          params: {
            region: isNull(regionId) ? idOfRegion.value : regionId,
            page: pagination.value.page,
            limit: pagination.value.perPage,
          },
        }),
      )
      list.value = response.documents
      region.value.id = response.region.id
      region.value.name = response.region.name
      pagination.value.totalPage = response.pagination.totalPage
    } finally {
      finishLoading()
    }
  }

  function findOne({ id }) {
    return api.district.findOne({ id })
  }

  function create({ body }) {
    return api.district.create(Object.assign(body, { region: idOfRegion.value }))
  }

  function edit({ id, body }) {
    return api.district.edit({
      id,
      body: {
        ...body,
        region: idOfRegion.value,
      },
    })
  }

  return {
    list,
    pagination,
    paginationMeta,
    tableColumns,
    isLoading,
    region,

    create,
    edit,
    findOne,
    findAll,
    resetList,
  }
}
